/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import { Button, Card, Intent } from "@blueprintjs/core"
import { MouseEvent, useEffect, useState } from "react"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { ScalableDialog } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import Editor from "./Editor"
import CardTemplateForm from "./CardTemplateForm"
import { CardsContent } from "src/modules/pe-landing-module/data/interfaces"
import CardFieldPanel from "./CardFieldPanel"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import SingleCardFieldPanel from "./SingleCardFieldPanel"

/* Protopia Ecosystem component */
export interface IindexProps {
   data: CardsContent 
}
const CardTemplateScalar = (props: IindexProps): JSX.Element => {
    useEffect(() => {
        useLandingStore.setState({ 
            currentCardEdit: props.data,
            selectedCardField: null
        }) 
    }, [])
    const [ isOpen, setIsOpen ] = useState<boolean>( false )

    const onEditTemplate = ( evt: MouseEvent ) => {
        evt.preventDefault()
        evt.stopPropagation()
        setIsOpen(true)
    }
    return <>
        <a href="#" className="small px-2 ml-1" onClick={ onEditTemplate }>
            <div className="small letter-spacing-1"> {__( "Card template editor" )} </div>
        </a>
        <ScalableDialog
            isOpen={ isOpen }
            dialogSize={ DIALOG_SIZE.NORMAL }
            portalClassName="z-index-80"
            usePortal={false}
        >
            <div className="w-100 h-100 position-relative">
                <Card className="p-1 w-100 d-flex align-items-center bg-dark text-light border-bottom border-light">
                    <div className="lead text-uppercase">
                        { __( "Card template editor" ) }
                    </div>
                    <Button intent={Intent.DANGER} className="ml-auto p-2" icon="cross" onClick={() => setIsOpen(false)} >
                        {__("Close and not save")}
                    </Button>
                    <Button intent={Intent.SUCCESS} className="ml-1 p-2" icon="floppy-disk" onClick={() => setIsOpen(false)} >
                        {__("Close and save")}
                    </Button>
                    
                </Card>
                <Editor>
                    <CardTemplateForm />
                    {/* <CardFieldPanel />
                    <SingleCardFieldPanel /> */}
                </Editor>
            </div>
        </ScalableDialog>

    </>
}
export default CardTemplateScalar